/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Pos_Order_SuccessInputs */

const vi_toast_pos_order_success = /** @type {(inputs: Toast_Pos_Order_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đặt hàng thành công`)
};

/**

* @param {Toast_Pos_Order_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_pos_order_success = /** @type {((inputs?: Toast_Pos_Order_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Pos_Order_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_pos_order_success(inputs)
});